<template>
  <div class="relative text-left">
    <div :id="dropdownId">
      <div
        class="flex w-full cursor-pointer select-none items-center justify-center space-x-0.5 text-xs"
        @click="toggleDropdown()"
      >
        <span class="whitespace-nowrap" v-if="Object.keys(gasFees).length > 0">
          <span class="text-gray-300 hover:text-white">Gas:</span> {{ decimals(gweiFee.fast.gwei, 0, 0) }}
        </span>
        <span class="whitespace-nowrap" v-else><span class="text-gray-300">Gas:</span> n/a</span>&nbsp;<span
          class="font-mono text-xs text-gray-400"
        ></span>
        <ChevronDownIcon
          :class="{ 'rotate-180': showDropdown }"
          class="-ml-0.5 h-4 w-4 transform text-gray-400 duration-100 ease-in-out"
        />
      </div>

      <div v-if="gasFees.length != 0 && showDropdown" class="relative">
        <div class="fixed inset-0 z-40" @click="closeGasFee()"></div>
        <div class="absolute right-0 z-50 mt-1">
          <div class="flex flex-col rounded border border-grid bg-gray-800 p-3">
            <table>
              <thead>
                <tr class="border-none">
                  <th>
                    <div class="items-center">
                      <BaseButton type="primary" size="xs" @press="toggleAlertsDialog()">+ Create Alert </BaseButton>
                    </div>
                  </th>
                  <th class="px-3 py-0 text-right text-xs font-normal normal-case text-gray-300">Standard</th>
                  <th class="px-3 py-0 text-right text-xs font-normal normal-case text-gray-300">Fast</th>
                  <th class="px-3 py-0 text-right text-xs font-normal normal-case text-gray-300">Instant</th>
                </tr>
              </thead>
              <tbody>
                <tr class="border-none">
                  <td class="py-0"></td>
                  <template v-for="(fee, idx) in gweiFee" :key="idx">
                    <td class="whitespace-nowrap px-3 text-right text-xs font-medium">
                      {{ decimals(fee.gwei, 0, 0) }} Gwei
                    </td>
                  </template>
                </tr>
                <tr v-for="(gf, idx) in gasFees" class="border-none" :key="idx">
                  <td class="whitespace-nowrap px-3 py-1 text-xs text-gray-300">{{ gf.description }}</td>
                  <td class="px-3 py-1 text-right">
                    <span class="text-xs text-white">${{ decimals(gf.fees.standard.usd, 2, 2) }}</span>
                  </td>
                  <td class="px-3 py-1 text-right">
                    <span class="text-xs text-white">${{ decimals(gf.fees.fast.usd, 2, 2) }}</span>
                  </td>
                  <td class="px-3 py-1 text-right">
                    <span class="text-xs text-white">${{ decimals(gf.fees.instant.usd, 2, 2) }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <ChartGasFee class="mt-4" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { decimals } from '@/composeables/filters';
import { ref, onMounted, inject, computed } from 'vue';
import ChartGasFee from '@/components/chart/ChartGasFee.vue';
import useEmitter from '@/composeables/emitter';
import { ChevronDownIcon } from '@heroicons/vue/20/solid';
import { useStore } from 'vuex';

const $http = inject('http');
const emitter = useEmitter();
const dropdownId = ref(`gas_fee_chart_${Math.random()}`);
const showDropdown = ref(false);
const $store = useStore();

onMounted(() => {
  setInterval(() => {
    getGasFees();
  }, 60000);
});

const gasFees = computed(() => {
  return $store.getters.gasFees;
});

const gweiFee = computed(() => {
  return gasFees.value?.['swap_transaction']?.fees || {};
});

function closeGasFee() {
  showDropdown.value = false;
}

function toggleDropdown() {
  showDropdown.value = !showDropdown.value;
}

async function getGasFees() {
  let response = await $http.get('/data/gas_fees');
  $store.commit('setGasFees', response.data);
}

function toggleAlertsDialog() {
  emitter.$emit('clear:alert');
  emitter.$emit('toggle:alerts-dialog', { mode: 'gas' });
  closeGasFee();
}
</script>
